import {addressKeys} from '.';
import React from 'react';
import {Header} from 'semantic-ui-react';
import {Form} from '../forms';
import {BillingAddressCollectionTypes, PaymentSourceTypes} from '../api/generated/enums';

type BillingAddressFormFields = {
  billingAddressCollectionType: BillingAddressCollectionTypes;
  paymentSourceType: PaymentSourceTypes;
  optionalZip?: boolean;
};

export const BillingAddressFormFields: React.FC<BillingAddressFormFields> = (props) => {
  const {billingAddressCollectionType, optionalZip = false} = props;
  if (billingAddressCollectionType === 'None') {
    return null;
  }

  const isRequired =
    props.paymentSourceType === 'Credit Card' && billingAddressCollectionType === 'Full Address';

  return (
    <>
      {billingAddressCollectionType === 'Full Address' && (
        <>
          <Header>Billing Address</Header>
          <Form.Input
            fieldName={addressKeys.streetAddress}
            fieldLabel="Street Address"
            className="short"
            fieldRequired={isRequired}
          />
          <Form.Input
            fieldName={addressKeys.streetAddress2}
            fieldLabel="Street Address 2"
            className="short"
          />
          <Form.Input
            fieldName={addressKeys.city}
            fieldLabel="City"
            className="short"
            fieldRequired={isRequired}
          />
          <Form.Input
            fieldName={addressKeys.state}
            fieldLabel="State"
            className="short"
            fieldRequired={isRequired}
          />
        </>
      )}
      <Form.Input
        fieldName={addressKeys.zipCode}
        fieldLabel={`Zip Code${optionalZip ? ' (optional)' : ''}`}
        className="short"
        fieldRequired={isRequired && !optionalZip}
      />
    </>
  );
};
